import { EventEmitter } from "@angular/core";
var ItemsComponent = /** @class */ (function () {
    function ItemsComponent() {
        this.action = new EventEmitter();
        setTimeout(function () {
            //console.log(this.items)
        }, 2000);
    }
    return ItemsComponent;
}());
export { ItemsComponent };
